-
<template>
  <div class="comment-carousel-controls">
    <FriedIconButton
      data-external="comment-carousel-controls-back-button"
      :disabled="previousDisabled"
      @click="$emit('previous')"
      ><FriedIcon icon="chevron-left" />
    </FriedIconButton>
    <FriedH5> {{ text }} </FriedH5>
    <FriedIconButton
      data-external="comment-carousel-controls-forward-button"
      :disabled="nextDisabled"
      @click="$emit('next')"
    >
      <FriedIcon icon="chevron-right" />
    </FriedIconButton>
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  props: {
    currentCommentIndex: {
      type: Number,
      default: 0,
    },
    totalCommentsCount: {
      type: Number,
      default: 0,
    },
  },
  emits: ['previous', 'next'],
  setup(props) {
    const { t } = useI18n();
    const text = computed(() =>
      t('cc_number_of_total_comments', {
        number: props.currentCommentIndex + 1,
        total: props.totalCommentsCount,
      })
    );

    const previousDisabled = computed(() => props.currentCommentIndex === 0);
    const nextDisabled = computed(() => props.currentCommentIndex === props.totalCommentsCount - 1);
    return {
      previousDisabled,
      nextDisabled,
      text,
    };
  },
});
</script>
<style lang="scss" scoped>
.comment-carousel-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-50);
}
</style>
